// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.aq4JWHl_rISf72L5VVy1{justify-content:space-between;padding-top:22px;display:flex}.aq4JWHl_rISf72L5VVy1 .hhOOVjKZE_I94Zs77o7O{gap:8px;display:flex}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"actions": `aq4JWHl_rISf72L5VVy1`,
	"right": `hhOOVjKZE_I94Zs77o7O`
};
export default ___CSS_LOADER_EXPORT___;
